import React from "react";

export default function Footer() {
  return (
    <footer className="mt-auto px-6 pb-6 md:px-12 md:pb-8 text-center md:text-left">
      <div className="text-sm text-[#2B7F8D]">
        <a href="#powered" className="font-bold underline">
          Powered by the One Door platform
        </a>
        <span> – © {new Date().getFullYear()} One Door. All rights reserved.</span>
      </div>
    </footer>
  );
}
